import { Edit, Eye, Trash } from "tabler-icons-react";

export const jobsHeader = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },

  //give full width to the question column
  {
    id: "jobTitle",
    numeric: false,
    disablePadding: true,
    label: "Job Title",
  },
  {
    id: "empLocation.locationName",
    numeric: false,
    disablePadding: true,
    label: "Location",
  },
  {
    id: "jobDescription",
    numeric: false,
    disablePadding: true,
    label: "Description",
  },
  {
    id: "salaryRange",
    numeric: false,
    disablePadding: true,
    label: "Salary Range",
  },
  {
    id: "actions",
    view: <Eye />,
    edit: <Edit />,
    delete: <Trash />,
    numeric: false,
    label: "Actions",
  },
];
